import { actions } from "../../utils/constants/main";

const initialState = {
  loading: true,
  data: [],
};
const sourceReducer = (state = initialState, action) => {
  switch (action.type) {
    case actions.SET_SOURCE_DATA:
      return { ...state, loading: false, data: action.data };
    case actions.START_SOURCE_LOADING:
      return { ...state, loading: true };
    case actions.ADD_SOURCE_DATA:
      const newDoc = action.data;
      const newData = [...state.data];
      newData.push(newDoc);
      newData.sort((a, b) => a.priority - b.priority);
      return { ...state, loading: false, data: newData };
    case actions.CLEAR_SOURCE_DATA:
      return { ...state, loading: false, data: [] };
    default:
      return { ...state };
  }
};
export default sourceReducer;
